import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => {
  return mergeStyleSets({
    rangeValueEditor: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    }
  })
}
